const commonMessages = {
  OLD_NEW_SAME_PASSWORD: "Old password & new password must be different",
  EMAIL_REQUIRED: "Email is required. Please enter your email.",
  VALID_EMAIL: "Email format is valid.",
  PASSWORD_REQUIRED: "Password is required.",
  NEW_PASSWORD_REQUIRED: "New password is required.",
  CONFIRM_PASSWORD_REQUIRED: "Confirm password is required.",
  VALID_PASSWORD:
    "Password should have at least 8 characters and contain uppercase letters, special characters, and numeric values.",
  NEWPASSWORD_CONFIRMPASSWORD_SAME:
    "New password and confirm password must be same.",
  SURVEY_CATEGORY_REQUIRED: "Survey category name is required.",
  FAQ_QUESTION_REQUIRED: "Faq question is required.",
  FAQ_ANSWER_REQUIRED: "Faq answer is required.",
  REPLY_MESSAGE_REQUIRED:"Reply message is required.",
  OLD_PASSWORD_REQUIRED:"Old password is required",
  OTP_REQUIRED:"OTP is required",
};

export default commonMessages;
